// Car single-page fuel-cost calculator. Three sliders → litri/lună, cost/lună,
// cost/zi. Pure client-side, no network.
import { qs, qsa, on } from '../lib/dom.js';
import { t } from '../lib/i18n.js';

const nfInt = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });

// Default slider values used on first render and on reset. The PHP template
// mirrors these via each input's value=/data-default (on the single car page the
// consumption default is overridden with the car's own figure). This map is the
// client-side source of truth so reset always returns to a sane default even if
// data-default is missing.
const DEFAULTS = { consum: 5.5, km: 1200, pret: 26 };

function fmtSlider(key, v) {
  switch (key) {
    case 'consum': return v.toFixed(1) + ' ' + t('fuel_l100km', 'l/100 km');
    case 'km':     return nfInt.format(v) + ' ' + t('fuel_km', 'km');
    case 'pret':   return v.toFixed(2).replace('.', ',') + ' ' + t('fuel_lei', 'lei');
    default:       return String(v);
  }
}

export function initFuelCalc() {
  const root = qs('[data-component="fuel-calc"]');
  if (!root) return;

  const sliders = qsa('[data-fuel]', root);
  const val = (k) => {
    const el = qs(`[data-fuel="${k}"]`, root);
    return el ? (parseFloat(el.value) || 0) : 0;
  };
  const setResult = (k, txt) => {
    const el = qs(`[data-fuel-result="${k}"]`, root);
    if (el) el.textContent = txt;
  };

  // Update the value label next to each slider. The track itself uses the
  // shared `.ap-slider` hairline styling (no JS-painted fill).
  function paintSlider(el) {
    const v = parseFloat(el.value);
    const out = qs(`[data-fuel-out="${el.dataset.fuel}"]`, root);
    if (out) out.textContent = fmtSlider(el.dataset.fuel, v);
  }

  function update() {
    const consum = val('consum');           // l/100km
    const km = val('km');                    // km/lună
    const pret = val('pret');                // lei/l

    const liters = (consum * km) / 100;
    const month = liters * pret;
    const day = month / 30;                  // average daily cost over a 30-day month

    setResult('liters', nfInt.format(Math.round(liters)) + ' ' + t('fuel_liters', 'L'));
    setResult('month', nfInt.format(Math.round(month)) + ' ' + t('fuel_lei', 'lei'));
    setResult('day', nfInt.format(Math.round(day)) + ' ' + t('fuel_lei', 'lei'));
  }

  sliders.forEach((s) => {
    paintSlider(s);
    on(s, 'input', () => { paintSlider(s); update(); });
  });

  const resetBtn = qs('[data-fuel-reset]', root);
  if (resetBtn) {
    on(resetBtn, 'click', () => {
      sliders.forEach((s) => {
        const dflt = s.dataset.default != null && s.dataset.default !== ''
          ? s.dataset.default
          : DEFAULTS[s.dataset.fuel];
        if (dflt != null) s.value = dflt;
        paintSlider(s);
      });
      update();
    });
  }

  update();
}
